import React, {useCallback, useMemo} from 'react';
import {useDispatch} from 'react-redux';

import {Group} from '@pb/kit-component-group';
import {Tab, Tabs} from '@pb/kit-component-tabs-v2';

import {replace} from '../entitlement-drawer.slice';

import {NotAssociatedGrantsTable} from './components/not-associated-grants-table';
import {NotAssociatedResourcesTable} from './components/not-associated-resources-table';
import {NotAssociatedRolesTable} from './components/not-associated-roles-table';

import type {OpenRequest} from 'src/modules/entitlements/components/drawer/typedef';

type Props = {
    currentEntitlement: OpenRequest,
};

export const NotAssociatedView = ({currentEntitlement}: Props) => {
    const dispatch = useDispatch();

    const activeTab = useMemo(() => (
        currentEntitlement?.notAssociatedEntitlementsDetails?.activeTab || 'grants'
    ), [currentEntitlement]);

    const changeTab = useCallback((tab: string) => {
        if (currentEntitlement?.notAssociatedEntitlementsDetails) {
            dispatch(replace({
                ...currentEntitlement,
                notAssociatedEntitlementsDetails: {
                    ...currentEntitlement.notAssociatedEntitlementsDetails,
                    pagination: {currentPage: 1, pageSize: 10},
                    activeTab: tab,
                },
            }));
        }
    }, [currentEntitlement, dispatch]);

    return (
        <Group direction="v" alignItems="start" style={{width: 500}}>
            <Tabs value={activeTab} onChange={changeTab} style={{width: '100%'}}>
                <Tab caption="Roles" value="roles"/>
                <Tab caption="Grants" value="grants"/>
                <Tab caption="Resources" value="resources"/>
            </Tabs>
            {activeTab === 'roles' ? (
                <NotAssociatedRolesTable currentEntitlement={currentEntitlement}/>
            ) : null}
            {activeTab === 'grants' ? (
                <NotAssociatedGrantsTable currentEntitlement={currentEntitlement}/>
            ) : null}
            {activeTab === 'resources' ? (
                <NotAssociatedResourcesTable currentEntitlement={currentEntitlement}/>
            ) : null}
        </Group>
    );
};
